import { uniqueBy } from 'remeda';
import { buildDefaultSlashCommandItems } from './items';
export const getSlashCommandItems = ({ editor, helpers, additionalItems = [], }) => {
    const baseItems = buildDefaultSlashCommandItems(editor, helpers);
    // Merge additionalItems before baseItems, removing duplicates by id.
    // uniqueBy keeps the first occurrence of each id, so additionalItems override base items with the same id.
    return uniqueBy([...additionalItems, ...baseItems], (item) => item.id).filter((item) => !item.isAvailable || item.isAvailable(editor, helpers));
};
